export enum OperationTypes {
  ARRIVE = 'Arrive',
  DEPART = 'Depart',
}
